import { render, staticRenderFns } from "./x-selected-filters-list.component.vue?vue&type=template&id=58ae46f1&scoped=true"
import script from "./x-selected-filters-list.component.vue?vue&type=script&lang=ts"
export * from "./x-selected-filters-list.component.vue?vue&type=script&lang=ts"
import style0 from "./x-selected-filters-list.component.vue?vue&type=style&index=0&id=58ae46f1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58ae46f1",
  null
  
)

export default component.exports